"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = require("styled-components");
var _ChoiceChipsSelector = require("./ChoiceChipsSelector.styles");
var _theme = require("../utils/theme");
var _FormOptionChip = _interopRequireDefault(require("../FormOptionChip/FormOptionChip"));
var _excluded = ["theme", "children", "chips", "initialValue", "onChange"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var ChoiceChipsSelector = function ChoiceChipsSelector(_ref) {
  var _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? _theme.defaultTheme : _ref$theme,
    children = _ref.children,
    _ref$chips = _ref.chips,
    chips = _ref$chips === void 0 ? [] : _ref$chips,
    initialValue = _ref.initialValue,
    _onChange = _ref.onChange,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useState = (0, _react.useState)(chips.length > 0 ? chips[0] : null),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    selectedChip = _useState2[0],
    setSelectedChip = _useState2[1];
  var getBorderRadius = function getBorderRadius(chip) {
    if (chips.length === 1) {
      return '50px';
    }
    if (chips.indexOf(chip) === 0) {
      return '50px 0  0 50px';
    } else if (chips.lastIndexOf(chip) === chips.length - 1) {
      return '0 50px 50px 0';
    }
    return '0';
  };
  (0, _react.useEffect)(function () {
    if (initialValue) {
      setSelectedChip(initialValue);
    }
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement(_ChoiceChipsSelector.ChipsSelector, props, chips.map(function (chip) {
    return /*#__PURE__*/_react["default"].createElement(_FormOptionChip["default"], {
      label: chip,
      isSelected: selectedChip === chip,
      onChange: function onChange() {
        setSelectedChip(chip);
        if (_onChange) _onChange(chip);
      },
      style: {
        borderRadius: getBorderRadius(chip),
        width: '100%'
      }
    });
  })));
};
var _default = exports["default"] = ChoiceChipsSelector;